import React from "react";
import {Box,Paper,Typography} from "@mui/material";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import BuildModel from "../BuildModel";
import ANN from "../ANN";
import Forecasting from "../Forecasting";
import ScatterPlotMethod from "../ScatterPlotMethod";

function AllBuildModel(props) {
  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const NextStep = () => {
    props.handleNextStep();
  };
  return (
  <Box sx={{ px: 2, py: 2 }}>

    <Paper
      elevation={0}
      sx={{
        borderRadius: "22px",
        p: 2,
        bgcolor: "#fff",
        boxShadow:
          "0px 8px 30px rgba(0,0,0,.06)"
      }}
    >
      <TabContext value={value}>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 2
          }}
        >

          <TabList
            onChange={handleChange}

            TabIndicatorProps={{
              style: {
                display: "none"
              }
            }}

            sx={{

              bgcolor:"#f8fafc",

              borderRadius:"16px",

              p:.7,

              minHeight:"auto",

              "& .MuiTabs-flexContainer":{
                gap:1
              }
            }}
          >

            {[
              {label:"MLOps",value:"1"},
              {label:"Deep Learning",value:"2"},
              {label:"Scatter Plot",value:"4"}
            ].map((tab)=>(

              <Tab
                key={tab.value}
                value={tab.value}
                label={tab.label}

                sx={{

                  textTransform:"none",

                  fontSize:"12px",

                  minHeight:40,

                  fontWeight:500,

                  borderRadius:"12px",

                  color:"#444",

                  transition:".3s",

                  px:3,

                  "&.Mui-selected":{

                    color:"#fff",

                    background:
                    "linear-gradient(90deg,#0078c9,#0d8fe6)",

                    boxShadow:
                    "0px 8px 18px rgba(0,120,201,.25)"
                  }
                }}
              />

            ))}

          </TabList>

        </Box>


        <Box
          sx={{
            mt:2,
            p:2,
            borderRadius:"18px",
            bgcolor:"#fff",
            minHeight:"500px",

            boxShadow:
            "0px 4px 18px rgba(0,0,0,.04)"
          }}
        >

          <TabPanel
            value="1"
            sx={{p:0}}
          >
            <BuildModel
              editAccess={props.editAccess}
              handleNextStep={props.handleNextStep}
              loaded={props.loaded}
              ProjectID={props.ProjectID}
            />
          </TabPanel>


          <TabPanel
            value="2"
            sx={{p:0}}
          >
            <ANN
              editAccess={props.editAccess}
              handleNextStep={props.handleNextStep}
              loaded={props.loaded}
              ProjectID={props.ProjectID}
            />
          </TabPanel>


          <TabPanel
            value="3"
            sx={{p:0}}
          >
            <Forecasting
              editAccess={props.editAccess}
              handleNextStep={props.handleNextStep}
              loaded={props.loaded}
              ProjectID={props.ProjectID}
            />
          </TabPanel>


          <TabPanel
            value="4"
            sx={{p:0}}
          >
            <ScatterPlotMethod
              editAccess={props.editAccess}
              handleNextStep={props.handleNextStep}
              loaded={props.loaded}
              ProjectID={props.ProjectID}
            />
          </TabPanel>

        </Box>

      </TabContext>

    </Paper>

  </Box>
);
}

export default AllBuildModel;
